import { ParsedQs } from 'qs';

export const parseQueryValue = (value?: string | ParsedQs | Array<string> | Array<ParsedQs>): string | null =>
  typeof value === 'string' ? decodeURIComponent(value) : null;
